import React from "react";
import axios from "axios";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";
import Pagination from "react-bootstrap/Pagination";
import loading from "./assets/loading.gif";

import "./Snapshots.css";
import "font-awesome/css/font-awesome.min.css";

class Snapshots extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      orderExports: [],
      currentPage: this.getQueryParam("page")
        ? parseInt(this.getQueryParam("page"))
        : 1,
      perPage: 50,
      totalCount: 0,
      totalPages: 0,
    };
  }

  getQueryParam = (param) => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(param);
  };

  async fetchOrderExports() {
    this.setState({ loading: true });

    try {
      const params = new URLSearchParams({
        page: this.state.currentPage,
        per_page: this.state.perPage,
      }).toString();

      const response = (await axios.get(`/api/order_exports?${params}`)).data;

      this.setState({
        orderExports: response.data,
        totalCount: response.pagination.total_count,
        totalPages: response.pagination.total_pages,
        loading: false,
      });
    } catch (error) {
      console.error("Error fetching order exports:", error);
      this.setState({ loading: false });
    }
  }

  async componentDidMount() {
    await this.fetchOrderExports();
  }

  handlePageChange = (newPage) => {
    this.setState({ currentPage: newPage }, () => {
      this.fetchOrderExports();
      window.history.pushState(
        null,
        "",
        `/snapshots?page=${newPage}&per_page=${this.state.perPage}`
      );
    });
  };

  handleDownload = async (orderExport) => {
    const response = await axios.get(
      `/api/order_exports/${orderExport.id}/download`,
      { responseType: "blob" }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", orderExport.filename);
    document.body.appendChild(link);
    link.click();
    // link.parentChild.removeChild(link);
    // window.URL.revokeObjectURL(url);
  };

  renderPaginationItems = () => {
    const { currentPage, totalPages } = this.state;
    const items = [];
    const maxPagesToShow = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    if (currentPage > 1) {
      items.push(
        <Pagination.First
          key="first"
          onClick={() => this.handlePageChange(1)}
        />
      );
      items.push(
        <Pagination.Prev
          key="prev"
          onClick={() => this.handlePageChange(currentPage - 1)}
        />
      );
    }

    for (let i = startPage; i <= endPage; i++) {
      items.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => this.handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    if (currentPage < totalPages) {
      items.push(
        <Pagination.Next
          key="next"
          onClick={() => this.handlePageChange(currentPage + 1)}
        />
      );
      items.push(
        <Pagination.Last
          key="last"
          onClick={() => this.handlePageChange(totalPages)}
        />
      );
    }

    return items;
  };

  render() {
    const {
      loading,
      orderExports,
      currentPage,
      perPage,
      totalCount,
      totalPages,
    } = this.state;

    return (
      <div className="snapshots-container">
        <h1 className="snapshots-title">Order Snapshots</h1>

        {!loading && (
          <div className="snapshots-info">
            <p>
              Showing{" "}
              {orderExports.length > 0 ? (currentPage - 1) * perPage + 1 : 0} to{" "}
              {Math.min(currentPage * perPage, totalCount)} of {totalCount}{" "}
              results (Page {currentPage} of {totalPages})
            </p>
          </div>
        )}

        {loading ? (
          <div className="loading-container">
            <img src={loading} alt="Loading..." />
          </div>
        ) : (
          <>
            <Table striped bordered hover className="snapshots-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Filename</th>
                  <th>Created At</th>
                  <th>Updated At</th>
                </tr>
              </thead>
              <tbody>
                {orderExports.map((orderExport) => (
                  <tr key={orderExport.id}>
                    <td>{orderExport.id}</td>
                    <td>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.handleDownload(orderExport);
                        }}
                        className="download-link"
                      >
                        {orderExport.filename}
                      </a>
                    </td>
                    <td>{new Date(orderExport.created_at).toLocaleString()}</td>
                    <td>{new Date(orderExport.updated_at).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </Table>

            {totalPages > 1 && (
              <div className="snapshots-pagination">
                <Pagination>{this.renderPaginationItems()}</Pagination>
              </div>
            )}
          </>
        )}
      </div>
    );
  }
}

export default Snapshots;
